import React from 'react'
import { Link as RouterLink, useLoaderData,createBrowserRouter, createRoutesFromElements, Navigate, Await, BrowserRouter, Route, Routes, NavLink, useNavigate, useLocation, useOutlet} from 'react-router-dom'
const serverpy_template=`import os
import sys
from flask import Flask, jsonify, request, render_template
from flask_cors import CORS, cross_origin
from dotenv import load_dotenv
load_dotenv()
app = Flask(__name__)
cors = CORS(app, support_credentials=True)
sys.path.insert(0, os.path.dirname(__file__))
@app.route('/')
@cross_origin(supports_credentials=True)
def hello_word():
   return 'Hello World'
if __name__=='__main__': 
   app.run(host="0.0.0.0", port=5000, debug=True) 
`
export default function PythonPage2() {
   return (
      <div className='text-left m-auto md:mt-8 w-full md:w-[580px] lg:w-[780px]'>
         <h2 className='mb-4 text-lg structure__main__subttl'>Deploy your fullstack work</h2>
         <p className='text-sm mb-12'>Backend has to keep running by using application. Heroku has that kind of service if you want to run 1 backend url for free. For professionals, you would required to contract web hotsing company and use additional plan for running backend application.
         </p>
         {/* <h2 className='mb-4 text-lg structure__main__subttl'>Cpanel pro + node app</h2>
         <h2 className='mb-4 text-lg structure__main__subttl'>Cpanel pro + python app</h2>
         <h2 className='mb-4 text-lg structure__main__subttl'>AWS cloudfront - if your app includes aws login</h2> */}
      </div>
   )
}